export default "__VITE_ASSET__6dea764b__"